import React, { useState } from 'react';
import {
  Alert,
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  IconButton,
  MenuItem,
  Select,
  Snackbar,
  TextField,
  Typography
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch } from 'react-redux';
import { dupNewUser } from '../../../Redux/Actions/SelfServe';

const fieldLabelSx = {
  fontFamily: 'Inter, sans-serif',
  fontWeight: 500,
  fontSize: '16px',
  lineHeight: '19px',
  color: 'text.secondary',
  mb: '6px'
};

const ClientInfo = ({
  info,
  infoPopUPHandler,
  notification,
  setNotification
}) => {
  const initialState = {
    name: '',
    areaCode: '',
    pms: '',
    crm: [],
    followupToggle: true,
    enableFirstMessage: true,
    enableBot: true,
    PMSMappings: {}
  };
  const [form, setForm] = useState(initialState);
  const dispatch = useDispatch();

  const saveClickHandler = () => {
    const { crm, ...rest } = form;
    const payload = {
      ...rest,
      pms: form?.pms?.toLocaleLowerCase().replace(/ /g, ''),
      enableKnockCRM:
        form?.pms?.toLocaleLowerCase() !== 'entrata'
          ? crm.includes('Knock')
          : false,
      enableRentCafeCRM: crm.includes('RentCafe')
    };
    dispatch(dupNewUser({ payload, showNotification }));
  };

  const handleForm = e => {
    const { value, name } = e.target;
    if (name === 'pms') {
      setForm(prev => ({ ...prev, pms: value, crm: [] }));
    } else {
      setForm(prev => ({ ...prev, [name]: value }));
    }
  };

  const clearHandler = () => {
    setForm(prev => ({ ...prev, ...initialState }));
  };

  const showNotification = () => {
    setNotification('Client account created');
    infoPopUPHandler(false);
  };

  const closeNotification = () => {
    setNotification('');
  };

  const closePop = () => {
    infoPopUPHandler(false);
  };

  return (
    <>
      <Dialog open={info} onClose={closePop} maxWidth="sm" fullWidth>
        <DialogTitle
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <Typography
            variant="h6"
            sx={{ fontWeight: 500, color: 'text.secondary' }}
          >
            Client Information
          </Typography>
          <IconButton onClick={closePop} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Box sx={{ mb: '16px' }}>
            <Typography sx={fieldLabelSx}>Name</Typography>
            <TextField
              size="small"
              fullWidth
              name="name"
              value={form.name}
              onChange={handleForm}
              placeholder="Client name"
            />
          </Box>

          <Box
            sx={{
              display: 'flex',
              gap: '16px',
              mb: '16px'
            }}
          >
            <Box sx={{ flex: 1 }}>
              <Typography sx={fieldLabelSx}>PMS</Typography>
              <FormControl size="small" fullWidth>
                <Select
                  name="pms"
                  value={form.pms}
                  onChange={handleForm}
                  displayEmpty
                >
                  <MenuItem value="" disabled>
                    Select PMS
                  </MenuItem>
                  <MenuItem value="Yardi">Yardi</MenuItem>
                  <MenuItem value="Real page">RealPage</MenuItem>
                  <MenuItem value="Entrata">Entrata</MenuItem>
                </Select>
              </FormControl>
            </Box>

            <Box sx={{ flex: 1 }}>
              <Typography sx={fieldLabelSx}>CRM</Typography>
              <FormControl size="small" fullWidth>
                <Select
                  name="crm"
                  value={form.crm}
                  onChange={handleForm}
                  disabled={form?.pms?.toLowerCase() === 'entrata'}
                  displayEmpty
                  multiple
                  renderValue={selected =>
                    selected.length === 0 ? (
                      <Typography
                        sx={{ color: 'text.disabled', fontSize: '14px' }}
                      >
                        Select CRM
                      </Typography>
                    ) : (
                      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                        {selected.map(val => (
                          <Chip key={val} label={val} size="small" />
                        ))}
                      </Box>
                    )
                  }
                >
                  <MenuItem value="Knock">Knock</MenuItem>
                  {form?.pms?.toLowerCase() === 'yardi' && (
                    <MenuItem value="RentCafe">RentCafe</MenuItem>
                  )}
                </Select>
              </FormControl>
            </Box>
          </Box>
        </DialogContent>

        <DialogActions sx={{ px: '24px', py: '16px', gap: '8px' }}>
          <Button onClick={clearHandler} variant="text">
            Clear
          </Button>
          <Button
            variant="contained"
            onClick={saveClickHandler}
            disabled={!form.name}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={!!notification}
        autoHideDuration={4000}
        onClose={closeNotification}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert onClose={closeNotification} severity="success">
          {notification}
        </Alert>
      </Snackbar>
    </>
  );
};

export default ClientInfo;
